import { Field, LinkField, RichTextField } from '@sitecore-jss/sitecore-jss-nextjs';
import {
  DynamicPlaceholderParams,
  TranslationOptionsParams,
  AnchorTargetParams,
  ImagePropertiesParams,
  RenderingProps,
} from 'src/shared/shared.types';

export type C14SidePhotoContentCardCarouselProps = RenderingProps<
  C14SidePhotoContentCardFields,
  C14SidePhotoContentCardParams,
  PhotoContentCardCarouselPlaceholder
>;
export interface C14SidePhotoContentCardFields {
  Headline?: Field<string>;
  SupportCopy?: RichTextField;
  SupportCopyBottom?: RichTextField;
  CTA?: LinkField;
}

export type C14SidePhotoContentCardParams = {
  HeadlineTag?: string;
  ContentAlignment?: string;
  CTAStyle?: string;
  BackgroundColor?: string;
  SlideTiming?: number;
  SlideLayout?: string;
} & DynamicPlaceholderParams &
  TranslationOptionsParams &
  AnchorTargetParams &
  ImagePropertiesParams;

export interface PhotoContentCardCarouselPlaceholder {
  'side-photo-content-cards-{*}'?: {
    componentName?: string;
  }[];
}
